import { render, staticRenderFns } from "./textDetails.vue?vue&type=template&id=08bde358&scoped=true&"
import script from "./textDetails.vue?vue&type=script&lang=js&"
export * from "./textDetails.vue?vue&type=script&lang=js&"
import style0 from "./textDetails.vue?vue&type=style&index=0&id=08bde358&prod&scoped=true&lang=css&"
import style1 from "./textDetails.vue?vue&type=style&index=1&id=08bde358&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bde358",
  null
  
)

export default component.exports